import { showEnquiryForm } from './forms.js';
import {
    addToShortlist,
    ensureCurrentOfficeRegistered,
    getCurrentOfficeData,
    getShortlistIds,
    isShortlisted,
    registerOffice,
    removeFromShortlist,
    syncShortlistUI,
} from './shortlist-store.js';

export function initShortlist() {
    ensureCurrentOfficeRegistered();
    syncShortlistUI();

    document.querySelectorAll('[data-shortlist-add]').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            handleShortlistToggle(button);
        });
    });

    const favoritesButton = document.querySelector('.favorites-btn');
    if (favoritesButton) {
        favoritesButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const isDetailsPage = document.body.id === 'details';

            // On details pages, add the current office if not already shortlisted
            if (isDetailsPage) {
                const office = getCurrentOfficeData();
                if (office.entryId && !isShortlisted(office.entryId)) {
                    addToShortlist(office.entryId, office);
                    syncShortlistUI();
                }
            }

            if (getShortlistIds().length) {
                showEnquiryForm('shortlist', {
                    officeIds: getShortlistIds(),
                    category: favoritesButton.dataset.category || '',
                });
            }
        });
    }
}

function handleShortlistToggle(button) {
    const office = getButtonOffice(button);
    if (!office) {
        return;
    }

    if (isShortlisted(office.entryId)) {
        removeFromShortlist(office.entryId);
        syncShortlistUI();
        return;
    }

    addToShortlist(office.entryId, office);
    syncShortlistUI();

    showEnquiryForm('shortlist', {
        officeIds: getShortlistIds(),
        category: button.dataset.category || '',
    });
}

function getButtonOffice(button) {
    const entryId = button.dataset.entryId;
    if (!entryId) {
        return null;
    }

    const currentOffice = getCurrentOfficeData();
    const fallbackTitle = currentOffice.entryId === entryId ? currentOffice.title : `Office ${entryId}`;
    const fallbackLocation = currentOffice.entryId === entryId ? currentOffice.location : '';
    const fallbackImage = currentOffice.entryId === entryId ? currentOffice.image : '/img/gallery-demo-image.jpg';

    const office = registerOffice({
        entryId,
        title: button.dataset.officeTitle || fallbackTitle,
        location: button.dataset.officeLocation || fallbackLocation,
        image: button.dataset.officeImage || fallbackImage,
        href: button.dataset.officeHref || window.location.href,
    });

    return office;
}
